import { Component } from '@angular/core';
import { LoaderService } from './services/loader.service';
import { MessageService } from './services/message.service';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  animations: [
    trigger('inOutFilters',
      [
        transition(
          ':enter',
          [
          style({ transform: 'translateY(100%)' }),
          animate('0.3s ease-in', style({ transform: 'translateY(0%)' }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ transform: 'translateY(0%)' }),
            animate('0.3s ease-in', style({ transform: 'translateY(100%)' }))
          ]
        )
      ]
    )
  ],
})

export class LoadingComponent {

  myLoader:boolean = false;
  myMessage: string = "";
  myMessageCss: string = "";
  showMessage: boolean = false;
  myTimeOut: any = null;

  constructor(public loaderService: LoaderService, public  messageService: MessageService) { }

    closeMessage() {
      clearTimeout(this.myTimeOut);
      this.myMessage = "";
      this.showMessage = false;
    }

    ngOnInit(): any {
      //stuff that doesn't do view changes
      //setTimeout(_=>  { });//setTimeout

             this.loaderService.changeEmitted$.subscribe((response: any) => { this.myLoader = response; });

            this.messageService.changeEmitted$.subscribe((response: any) => {
            this.myMessage = response.Message;
            this.myMessageCss = response.Css;
            this.showMessage = (response.Message ? true : false);

            clearTimeout(this.myTimeOut);

            let myTimer = 5000

            this.myTimeOut = setTimeout(() => {  //<<<---using ()=> syntax
              this.myMessage = "";
              this.showMessage = false;
            }, myTimer);
              });

      if (!navigator.onLine) { this.messageService.emitChange({ "Message": "You appear to be offline.", "Css": "error" }); }

    }





}


